import React, { createContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getStatusZone, getDownloadExcel } from "../../api/Api";
import RouteConstants from "../../constants/routesContent.json";

export const StatusZoneContext = createContext({});
export const StatusZoneContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const statusZone = location?.state?.status;
  const [memberList, setmemberList] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [pageNumber, setpageNumber] = useState(1);
  const [zoneNewExcel, setZoneNewExcel] = useState("");
  const [zoneActive, setZoneActive] = useState(1);
  const [excelDownload, setExcelDownload] = useState("");
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const [dataLoad, setDataLoad] = useState(false);
  const zone = "zone";

  const goBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    getStatusZoneData("zone", zoneActive, pageNumber);
  }, []);

  const getStatusZoneData = async (zone, activeZone, pageNumber) => {
    setDataLoad(true);
    const data = {
      zone: zone,
      activeZone: activeZone,
      currentPage: pageNumber,
    };
    try {
      const zoneData = await getStatusZone(data);
      if (zoneData.data.status === 200) {
        setDataLoad(false);
        setmemberList(zoneData?.data?.data?.employees);
        setPageCount(zoneData?.data?.data?.numPages);
        setExcelDownload(zoneData?.data?.data?.excelFile);
      }
    } catch (error) {
      setDataLoad(false);
      console.log("error ->", error);
    }
  };

  const downloadExcelSheet = async () => {
    setSpinnerStatus(true);
    const data = {
      search: "status",
      filter: "zone",
      empData: "",
      fromDate: "",
      toDate: "",
      zoneFilter: "",
      categoryFilter: "",
    };
    try {
      const response = await getDownloadExcel(data);
      if (response.data.status === 200) {
        setSpinnerStatus(false);
        setZoneNewExcel(response?.data?.data?.filename);
      }
    } catch (error) {
      setSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setShowAlert(true);
        setAlertMessage(error?.response?.data?.message);
      } else {
        setShowAlert(true);
        setAlertMessage("Something went wrong");
      }
    }
  };

  useEffect(() => {
    downloadExcelSheet();
  }, []);

  const onPageChange = (e) => {
    setpageNumber(e);
    getStatusZoneData(zone, zoneActive, e);
  };

  const changeActiveZone = (e) => {
    setmemberList([]);
    setpageNumber(1);
    setPageCount(1);
    setZoneActive(e);
    getStatusZoneData(zone, e, 1);
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteConstants.LOGIN);
  };

  const providerValue = {
    goBack,
    statusZone,
    getStatusZoneData,
    memberList,
    pageCount,
    onPageChange,
    zoneNewExcel,
    pageNumber,
    excelDownload,
    changeActiveZone,
    spinnerStatus,
    showAlert,
    statusCode,
    dataLoad,
    alertMessage,
    setShowAlert,
    logout,
  };
  return (
    <StatusZoneContext.Provider value={providerValue}>
      {children}
    </StatusZoneContext.Provider>
  );
};
